<button fd-button fdType="transparent" id="show-parent-data-btn" (click)="showParentData()"
        [title]="title">
    <app-icon [icon]="[$any('workspace'), $any('parentDetails')]" size="lg" [fixedWidth]="true"></app-icon>
</button>
